export const wxloginUrl = 'http://www.czgtgs.com/index.php/wxauth';
